export interface ReqLoginByPassword {
  phone: string | null;
  password: string | null;
}
export interface ReqRegisterComplete {
  code: string | null;
  token: string | null;
  password: string | null;
  firstName: string | null;
  lastName: string | null;
}
export interface ReqByPhoneComplete {
  code: string | null;
  token: string | null;
}
export enum Operation {
  Register = 'register',
  ByPhone = 'by-phone',
  ProfileConfirmPhone = 'profileConfirmPhone'
}
